const FALLBACK_ROW_HEIGHT = 30;

export const calculateInitialPageSize = () => {
  const gridEl = document.getElementById("gridcomp");

  if (!gridEl) {
    return Math.floor((window.innerHeight * 0.65 - 20) / FALLBACK_ROW_HEIGHT) || 10;
  }

  const headerEl = gridEl.querySelector(".e-gridheader");
  const pagerEl = gridEl.querySelector(".e-gridpager");
  const headerHeight = headerEl?.getBoundingClientRect().height ?? 42;
  const pagerHeight = pagerEl?.getBoundingClientRect().height ?? 42;

  const firstRow = gridEl.querySelector(".e-row");
  const rowHeight = firstRow
    ? firstRow.getBoundingClientRect().height
    : FALLBACK_ROW_HEIGHT;

  const px = (el, prop) =>
    parseFloat(el ? getComputedStyle(el)[prop] : 0) || 0;

  const belowGrid =
    px(gridEl.closest(".grid-component"), "paddingBottom") +
    px(gridEl.closest(".accordion-body"), "paddingBottom") +
    px(gridEl.closest(".accordion-item"), "marginBottom") +
    px(gridEl.closest(".container-xxl"), "paddingBottom") +
    px(document.querySelector(".movyx-content"), "paddingBottom");

  const { top } = gridEl.getBoundingClientRect();
  const available =
    window.innerHeight - top - headerHeight - pagerHeight - belowGrid;

  return Math.max(1, Math.floor(available / rowHeight + 0.5));
};
